export default __webpack_public_path__ + "static/media/colorectal3.ffd757dd.jpg";